module.exports = __webpack_public_path__ + "img/works_nikkei_telecon_1.75f03efb.png";